import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Goals from './pages/Goals';
import Projects from './pages/Projects';
import Relationships from './pages/Relationships';
import Places from './pages/Places';
import Health from './pages/Health';
import Campaigns from './pages/Campaigns';
import Contacts from './pages/Contacts';
import Vehicles from './pages/Vehicles';
import Habits from './pages/Habits';
import HabitHistory from './pages/HabitHistory';
import Bookmarks from './pages/Bookmarks';
import Blogs from './pages/Blogs';
import Users from './pages/Users';
import Preferences from './pages/Preferences';
import SitePreferences from './pages/SitePreferences';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import AuthCallback from './pages/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import UserRouter from './components/UserRouter';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminCompliance from './pages/admin/AdminCompliance';
import AdminDataRetention from './pages/admin/AdminDataRetention';
import AdminReports from './pages/admin/AdminReports';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navigation />}
      <main className={isAdminRoute ? '' : 'main-content'}>
        <Routes>
            {/* Public routes */}
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/goals" element={
              <ProtectedRoute>
                <Goals />
              </ProtectedRoute>
            } />
            <Route path="/projects" element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            } />
            <Route path="/relationships" element={
              <ProtectedRoute>
                <Relationships />
              </ProtectedRoute>
            } />
            <Route path="/places" element={
              <ProtectedRoute>
                <Places />
              </ProtectedRoute>
            } />
            <Route path="/health" element={
              <ProtectedRoute>
                <Health />
              </ProtectedRoute>
            } />
            <Route path="/campaigns" element={
              <ProtectedRoute>
                <Campaigns />
              </ProtectedRoute>
            } />
            <Route path="/contacts" element={
              <ProtectedRoute>
                <Contacts />
              </ProtectedRoute>
            } />
            <Route path="/vehicles" element={
              <ProtectedRoute>
                <Vehicles />
              </ProtectedRoute>
            } />
            <Route path="/habits" element={
              <ProtectedRoute>
                <Habits />
              </ProtectedRoute>
            } />
            <Route path="/habits/:id" element={
              <ProtectedRoute>
                <HabitHistory />
              </ProtectedRoute>
            } />
            <Route path="/bookmarks" element={
              <ProtectedRoute>
                <Bookmarks />
              </ProtectedRoute>
            } />
            <Route path="/blogs" element={
              <ProtectedRoute>
                <Blogs />
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            } />
            <Route path="/preferences" element={
              <ProtectedRoute>
                <Preferences />
              </ProtectedRoute>
            } />
            <Route path="/admin/site-preferences" element={
              <ProtectedRoute>
                <SitePreferences />
              </ProtectedRoute>
            } />
            
            {/* Admin routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="compliance" element={<AdminCompliance />} />
              <Route path="data-retention" element={<AdminDataRetention />} />
              <Route path="reports" element={<AdminReports />} />
            </Route>
            
            {/* Username routes - must come last to avoid conflicts */}
            <Route path="/:username" element={<UserRouter />} />
          </Routes>
        </main>
      </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
